import { Component, OnInit, PLATFORM_ID, AfterViewInit, ElementRef, ComponentFactoryResolver, ViewChild, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import VimeoPlayer from "@vimeo/player";
import { AngularFireFunctions } from '@angular/fire/functions';
import { isPlatformBrowser } from '@angular/common';

interface clase {
  archivos: archivo[],
  completado: number,
  descripcion: string,
  duracion: number,
  id: number,
  idVideo: number,
  numero: number,
  tipo: string,
  titulo: string,
  HTMLcontent: string,
  vigente: boolean
}

interface archivo {
  nombre: string;
  size: number;
  url: string;
  type: string;
}

@Component({
  selector: 'modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.css']
})
export class ModuloComponent implements OnInit {

  darkmode: boolean = true;
  public isBrowser = isPlatformBrowser(this.platformId)


  // Flag 

  loaded = 0;
  flagVideo = 0;

  mostrarExamen = 0;

  // Info de usuario

  // Info de Progreso
  progreso: any;
  clases: clase[];
  progresoTotal: number;
  claseActual: clase;
  idxActual: number;


  // Desbloquear Cuestionario
  mostrarCuestionario: number = 0

  // flag cargo video;
  cargoVideo = false;

  //media
  logoPredictiva21: string = "assets/images/logos/logo-predictiva-blanco-sm.png"
  selectedTab: number = 1;
  private player;

  //pdf
  page: number = 1;
  pdfSrc: string = '';


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private sanitizer: DomSanitizer,
    private shared: RoutingVariablesService,
    private functions: AngularFireFunctions,
    @Inject(PLATFORM_ID) private platformId: any,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  videoUrl;
  safeUrl;
  usuario = JSON.parse(localStorage.getItem('user'));
  instructor;

  ngOnInit(): void {
    console.log(this.isBrowser)
    this.cargarProgreso();
    this.cargarInstructor();

    // prevenir screenshots //////////////////////////////////////////
    document.addEventListener("keyup", function (e) {
      if (e.key == "PrintScreen") {
        navigator.clipboard.writeText('');
        alert('Screenshots disabled!');
      }
    });
    ////////////////////////////////////////////////////////////////////
  }

  cargarInstructor() {
    this.afs.doc(`cursos/${this.id}`).ref.get().then(snap => {
      const instructorId = snap.data()["instructorId"];
      this.afs.doc(`instructores/${instructorId}`).ref.get().then(snap => {
        this.instructor = snap.data();
      })
    })
  }

  // Inicializar video
  initPlayer() {
    this.cargoVideo = true;
    var iframe = document.querySelector('iframe');
    this.player = new VimeoPlayer(iframe, {});
    this.player.on('play', (data) => {
      this.flagVideo = 0;
    });
    const tolerance = 0.01
    this.player.on('timeupdate', (data) => {
      if (this.flagVideo == 0) {
        if (data.percent > 0.5) {
          this.flagVideo = 1;
          this.completar(this.idxActual);
        }
      }
    })
  }

  // cargar documento de progreso
  cargarProgreso() {
    this.afs.collection('usuariosProgresos').ref
      .where('cursoId', '==', this.id)
      .where('usuarioId', '==', this.usuario.uid)
      .get().then((response) => {
        response.docs.forEach((doc) => {
          this.progreso = doc.data();
        })
      }).then(() => {
        this.cargarclases();
      }).catch(error => {
        console.log(error)
      }).catch((error) => {
        console.log(error)
      })
  }

  cargarclases() {
    this.clases = this.progreso['clases'];
    let contador = 0;
    let ultimo = 0;
    let ultimoCero = 0
    for (let index = 0; index < this.clases.length; index++) {
      if (this.clases[index].completado == 1) {
        contador += 1;
        ultimo = index
      } else {
        ultimoCero = index
      }
    }
    // Calculo Progreso
    this.progresoTotal = +((contador * 100 / (this.clases.length)) * 0.9).toFixed(0);
    if (this.progreso['completado'] == true) {
      this.progresoTotal = 100;
    }
    // Calculo Sesion Actual
    if (this.progresoTotal >= 90) {
      this.claseActual = this.clases[ultimo]
      this.idxActual = ultimo;
    }
    else {
      if (ultimo == (this.clases.length - 1)) {
        this.claseActual = this.clases[ultimoCero];
        this.idxActual = ultimoCero;
      }
      else {
        if (contador == 0) {
          this.claseActual = this.clases[0]
          this.idxActual = 0
        } else {
          this.claseActual = this.clases[ultimo]
          this.idxActual = ultimo
        }
      }
    }
    if (this.shared.getModulo()) {
      const id = this.shared.getModulo();
      this.idxActual = this.clases.findIndex(x => x.id == id - 1);
      this.shared.seleccionarModulo(null)
      this.claseActual = this.clases[this.idxActual]
    }
    this.loaded = 1
    if (this.claseActual.tipo == "video") {
      this.videoUrl = "https://player.vimeo.com/video/" + this.claseActual.idVideo + "?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
    }

  }

  completar(idx) {
    if (this.clases[idx].completado == 0) {
      this.clases[idx].completado = 1;
      this.functions.httpsCallable("completarClase")({
        clases: this.clases,
        cursoId: this.id,
      }).toPromise().then(() => {
        let contador = 0
        for (let index = 0; index < this.clases.length; index++) {
          if (this.clases[index].completado == 1) {
            contador += 1;
          }
        }
        // Calculo Progreso
        this.progresoTotal = +((contador * 100 / (this.clases.length)) * 0.9).toFixed(0)
      }).catch(error => {
        console.log(error);
      })
    }
  }

  siguiente() {
    if (this.idxActual == (this.clases.length - 1)) {
    } else {
      this.idxActual += 1;
      this.claseActual = this.clases[this.idxActual]
      if (this.claseActual.tipo == 'video') {
        if (!this.cargoVideo) {
          this.videoUrl = "https://player.vimeo.com/video/" + this.claseActual.idVideo + "?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
          this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
        } else {
          this.cambiarVideo()
        }
      } else {
        this.cargoVideo = false
      }
    }
  }

  anterior() {
    if (this.idxActual == 0) {
    } else {
      this.idxActual -= 1
      this.claseActual = this.clases[this.idxActual]
      if (this.claseActual.tipo == 'video') {
        if (!this.cargoVideo) {
          this.videoUrl = "https://player.vimeo.com/video/" + this.claseActual.idVideo + "?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
          this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
        } else {
          this.cambiarVideo()
        }
      } else {
        this.cargoVideo = false
      }
    }
  }

  clickClases(i) {
    this.idxActual = i;
    this.claseActual = this.clases[this.idxActual]
    if (this.claseActual.tipo == 'video') {
      if (!this.cargoVideo) {
        this.videoUrl = "https://player.vimeo.com/video/" + this.claseActual.idVideo + "?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
      } else {
        this.cambiarVideo()
      }
    }
  }

  irCuestionario() {
    this.router.navigate(['/cuestionario', this.id]);
  }

  selectTab1() {
    this.selectedTab = 1;
  }

  selectTab2() {
    this.selectedTab = 2;
  }
  selectTab3() {
    this.selectedTab = 3;
  }

  cambiarVideo() {
    this.player.loadVideo(this.claseActual.idVideo).then(function (id) {
      // the video successfully loaded
      this.initPlayer()
    }).catch(function (error) {
      switch (error.name) {
        case 'TypeError':
          // the id was not a number
          break;

        case 'PasswordError':
          // the video is password-protected and the viewer needs to enter the
          // password first
          break;

        case 'PrivacyError':
          // the video is password-protected or private
          break;

        default:
        // some other error occurred
          break;
      }
    });
  }
}
